import React from 'react'
import { colors } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import omit from 'lodash/omit'
import { useTranslation } from 'react-i18next'
import { useFETelemetry } from '@talentinc/gatsby-theme-ecom/hooks/useTelemetry'
import useLocation from 'react-use/lib/useLocation'
import ContentfulButton from '../Buttons/ContentfulButton'
import DE from '@talentinc/gatsby-theme-ecom/images/DE.inline.svg'
import FR from '@talentinc/gatsby-theme-ecom/images/FR.inline.svg'
import UK from '@talentinc/gatsby-theme-ecom/images/UK.inline.svg'
import US from '@talentinc/gatsby-theme-ecom/images/US.inline.svg'
import { ActionLink, Button, ExternalLink } from 'types/page'
import useHreflangs from '../Hreflang/useHreflangs'
import { useMpEventType } from '@talentinc/gatsby-theme-ecom/utils/mixpanel'

const flagsMap: Record<string, React.FC<any>> = {
  flagUK: UK,
  flagDE: DE,
  flagFR: FR,
  flagUS: US,
}

interface Props {
  button: Button<ActionLink>
}

const LanguageButton: React.FC<Props> = ({ button }) => {
  const { classes } = useStyles()

  const { t } = useTranslation()
  const { pathname, protocol } = useLocation()
  const hreflangs = useHreflangs(pathname)

  const correspondingPage = hreflangs.find(
    ({ hreflang }) => hreflang === button.buttonText
  )

  const telemetry = useFETelemetry()
  const mpEventType = useMpEventType()

  const handleChangeLanguage = () => {
    let url
    if (correspondingPage) {
      const { url_path: path, domain } = correspondingPage
      url = `${protocol}//${domain}${path}`
    } else {
      const action = button?.action as ExternalLink
      url = `${action?.url}`
    }
    telemetry.track({
      event: 'click_nav_country',
      properties: {
        event_type: mpEventType,
        country_selected: button.buttonText,
        current_url: document.location.href,
      },
    })
    document.location.href = url
  }

  const flagId = (button?.codeClasses || [])[0] || 'flagUK'
  const FlagSvg = flagsMap[flagId] as React.FC<any>

  return (
    <ContentfulButton
      className={classes.container}
      onClick={handleChangeLanguage}
      data-qa-modal-submission-button
      startIcon={<FlagSvg />}
      buttonText={t(`language.${button.buttonText}`)}
      {...omit(button, ['role', 'buttonText', 'action'])}
    />
  )
}

const useStyles = makeStyles()((theme) => ({
  container: {
    marginRight: '1em',
    marginLeft: '1em',
    '&:hover': {
      color: colors.blue[300],
    },
    color: '#1E2532',
    marginBottom: '1.0em',
    '& svg': {
      width: '38px',
      height: '24px',
    },
  },
}))

export default LanguageButton
